import { LEADERSHIP, IMAGES } from "@/lib/site";

export default function Leadership() {
  return (
    <section
      id="leadership"
      data-testid="leadership-section"
      className="relative py-24 md:py-32 bg-[#0B1120]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-14">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-amber-500" />
            <span className="font-tech text-amber-400 text-xs">LEADERSHIP TEAM</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
            <span className="chrome-text">The People</span>
            <br />
            <span className="gold-text">Behind The Pipeline.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {LEADERSHIP.map((p, i) => (
            <article
              key={p.name}
              data-testid={`leadership-card-${i}`}
              className="forge-card group p-0 overflow-hidden"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={IMAGES[p.image]}
                  alt={p.name}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1120] via-[#0B1120]/30 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="font-tech text-[10px] text-orange-400 mb-1">
                    {p.role.toUpperCase()}
                  </div>
                  <h3 className="font-display text-2xl tracking-tight chrome-text">
                    {p.name}
                  </h3>
                </div>
              </div>
              <div className="p-6">
                <p className="font-body text-slate-400 text-sm leading-relaxed">
                  {p.bio}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
